import { X, CaretLeft, CaretRight } from "@phosphor-icons/react";
import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { toAbsolute } from "@/lib/apiClient";
import { motion, AnimatePresence } from "framer-motion";

export default function PhotoLightbox({ photos, initialIndex = 0, open, onClose }) {
    const [idx, setIdx] = useState(initialIndex);

    useEffect(() => {
        if (open) setIdx(initialIndex);
    }, [open, initialIndex]);

    const next = (e) => { e.stopPropagation(); setIdx((prev) => (prev + 1) % photos.length); };
    const prev = (e) => { e.stopPropagation(); setIdx((prev) => (prev - 1 + photos.length) % photos.length); };

    if (!photos || photos.length === 0) return null;

    const modalContent = (
        <AnimatePresence>
            {open && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    className="fixed inset-0 z-[9999] flex items-center justify-center p-4"
                    style={{ background: "rgba(0,0,0,0.9)", backdropFilter: "blur(10px)" }}
                    onClick={onClose}
                >
                    <button
                        onClick={onClose}
                        className="absolute top-4 right-4 z-[110] p-2 rounded-full bg-white/10 hover:bg-white/20 text-white transition-colors"
                    >
                        <X size={24} />
                    </button>

                    {photos.length > 1 && (
                        <button
                            onClick={prev}
                            className="absolute left-4 top-1/2 -translate-y-1/2 z-[110] p-3 rounded-full bg-white/10 hover:bg-white/20 text-white transition-colors"
                        >
                            <CaretLeft size={24} />
                        </button>
                    )}

                    <img
                        src={toAbsolute(photos[idx])}
                        alt={`Photo ${idx + 1}`}
                        className="max-w-full max-h-[90vh] object-contain pointer-events-none"
                        onClick={(e) => e.stopPropagation()}
                    />

                    {photos.length > 1 && (
                        <button
                            onClick={next}
                            className="absolute right-4 top-1/2 -translate-y-1/2 z-[110] p-3 rounded-full bg-white/10 hover:bg-white/20 text-white transition-colors"
                        >
                            <CaretRight size={24} />
                        </button>
                    )}
                    
                    {photos.length > 1 && (
                        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
                            {photos.map((_, i) => (
                                <div
                                    key={i}
                                    className={`w-2 h-2 rounded-full transition-all ${i === idx ? "bg-white scale-125" : "bg-white/30"}`}
                                />
                            ))}
                        </div>
                    )}
                </motion.div>
            )}
        </AnimatePresence>
    );

    return createPortal(modalContent, document.body);
}
